import api from 'api'

export type FieldglassCompanyGroup = {
  companyGroupId: number
  companyGroupName: string | null
  buyerUrl: string
}

export type ListFieldglassCompanyGroupsResponse = {
  items: FieldglassCompanyGroup[]
}

export const listFieldglassCompanyGroups =
  async (): Promise<ListFieldglassCompanyGroupsResponse> => {
    const response = await api.get<ListFieldglassCompanyGroupsResponse>(
      '/admin/fieldglass/company_groups'
    )
    return response.data
  }
